module.exports = __webpack_public_path__ + "img/ing.ed2efba6.png";